import axios from 'axios';

export default {
    methods: {
        async clienteIndex(d, ok, err) {
            try {
                let r = await axios.get('cliente?page=' + d.page, {params: d})
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async clienteStore(d, ok, err) {
            try {
                let r = await axios.post('cliente', d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async clienteUpdate(id, d, ok, err) {
            try {
                let r = await axios.put('cliente/' + id, d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async clienteShow(id, ok, err) {
            try {
                let r = await axios.get('cliente/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async clienteVincular(ok, err) {
            try {
                let r = await axios.post('cliente/vincular');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async clienteBuscar(d, ok, err) {
            try {
                let r = await axios.post('cliente/buscar', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async clienteCuitSearch(d, ok, err) {
            try {
                let r = await axios.post('cliente/cuit-search', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async clienteRzonSocSearch(d, ok, err) {
            try {
                let r = await axios.post('cliente/rzon-soc-search', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async clienteContactoTipos(ok, err) {
            try {
                let r = await axios.post('cliente/contacto-tipos');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/cliente.js